module.exports = __webpack_public_path__ + "static/logo-160e02c23bdd7f4cf044656f1b5ca868.jpg";